import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgHelpFillOff = (props) => /* @__PURE__ */ _jsxs("svg", {
	width: 24,
	height: 24,
	viewBox: "0 0 24 24",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [/* @__PURE__ */ _jsxs("mask", {
		id: "mask0_584_5743",
		style: { maskType: "alpha" },
		maskUnits: "userSpaceOnUse",
		x: 2,
		y: 2,
		width: 20,
		height: 20,
		children: [/* @__PURE__ */ _jsx("mask", {
			id: "mask1_584_5743",
			style: { maskType: "alpha" },
			maskUnits: "userSpaceOnUse",
			x: 0,
			y: 0,
			width: 24,
			height: 24,
			children: /* @__PURE__ */ _jsx("rect", {
				width: 24,
				height: 24,
				fill: "#D9D9D9"
			})
		}), /* @__PURE__ */ _jsx("g", {
			mask: "url(#mask1_584_5743)",
			children: /* @__PURE__ */ _jsx("path", {
				d: "M11.989 17.6154C12.2745 17.6154 12.5157 17.5168 12.7125 17.3196C12.9093 17.1225 13.0077 16.8811 13.0077 16.5956C13.0077 16.3101 12.9091 16.0689 12.7119 15.8721C12.5148 15.6753 12.2734 15.5769 11.9879 15.5769C11.7024 15.5769 11.4612 15.6755 11.2644 15.8727C11.0676 16.0698 10.9692 16.3111 10.9692 16.5967C10.9692 16.8822 11.0678 17.1234 11.265 17.3202C11.4621 17.517 11.7034 17.6154 11.989 17.6154ZM12.0016 21.5C10.6877 21.5 9.45268 21.2506 8.29655 20.752C7.1404 20.2533 6.13472 19.5766 5.2795 18.7217C4.42427 17.8669 3.74721 16.8616 3.24833 15.706C2.74944 14.5504 2.5 13.3156 2.5 12.0017C2.5 10.6877 2.74933 9.45271 3.248 8.29658C3.74667 7.14043 4.42342 6.13475 5.27825 5.27953C6.1331 4.4243 7.13834 3.74724 8.29398 3.24836C9.44959 2.74947 10.6844 2.50003 11.9983 2.50003C13.3122 2.50003 14.5473 2.74936 15.7034 3.24803C16.8596 3.7467 17.8652 4.42345 18.7205 5.27828C19.5757 6.13313 20.2527 7.13837 20.7516 8.29401C21.2505 9.44962 21.5 10.6844 21.5 11.9983C21.5 13.3123 21.2506 14.5473 20.752 15.7034C20.2533 16.8596 19.5765 17.8653 18.7217 18.7205C17.8669 19.5757 16.8616 20.2528 15.706 20.7517C14.5504 21.2505 13.3156 21.5 12.0016 21.5ZM12 20C14.2333 20 16.125 19.225 17.675 17.675C19.225 16.125 20 14.2333 20 12C20 9.76667 19.225 7.87501 17.675 6.32501C16.125 4.77501 14.2333 4.00001 12 4.00001C9.76664 4.00001 7.87498 4.77501 6.32498 6.32501C4.77498 7.87501 3.99998 9.76667 3.99998 12C3.99998 14.2333 4.77498 16.125 6.32498 17.675C7.87498 19.225 9.76664 20 12 20ZM12.081 7.71923C12.5424 7.71923 12.9416 7.86447 13.2788 8.15496C13.616 8.44544 13.7846 8.80854 13.7846 9.24426C13.7846 9.61092 13.6769 9.93912 13.4615 10.2289C13.2461 10.5186 13 10.7885 12.7231 11.0385C12.3601 11.3605 12.0405 11.7147 11.7643 12.1012C11.4881 12.4876 11.3404 12.918 11.3211 13.3923C11.3147 13.5744 11.3788 13.7269 11.5135 13.85C11.6481 13.9731 11.8051 14.0346 11.9846 14.0346C12.1769 14.0346 12.3397 13.9705 12.4731 13.8423C12.6064 13.7141 12.6916 13.5571 12.7288 13.3712C12.7955 13.0276 12.9375 12.7215 13.1548 12.4529C13.3721 12.1843 13.6075 11.9289 13.861 11.6867C14.2254 11.3315 14.5435 10.9441 14.8153 10.5247C15.0871 10.1053 15.223 9.63741 15.223 9.12118C15.223 8.32888 14.9109 7.67792 14.2865 7.16831C13.6622 6.65869 12.9333 6.40388 12.1 6.40388C11.5051 6.40388 10.9442 6.53561 10.4173 6.79908C9.89038 7.06253 9.48013 7.44682 9.18653 7.95196C9.09551 8.10707 9.06629 8.27035 9.09888 8.44178C9.13146 8.6132 9.21943 8.74336 9.3628 8.83226C9.54528 8.93384 9.73268 8.96283 9.92498 8.91923C10.1173 8.87565 10.2807 8.76604 10.4154 8.59041C10.6179 8.32757 10.8631 8.11667 11.1509 7.95771C11.4387 7.79872 11.7488 7.71923 12.081 7.71923Z",
				fill: "#1C1B1F"
			})
		})]
	}), /* @__PURE__ */ _jsx("g", {
		mask: "url(#mask0_584_5743)",
		children: /* @__PURE__ */ _jsx("rect", {
			width: 24,
			height: 24,
			fill: "#333333"
		})
	})]
});
export default SvgHelpFillOff;
